<template>
<div class="col-12 d-flex px-0 mb-2">
    <div class="col-8 mt-3 pl-0 align-items-center">
        <h3 class="c-ndarkthree mb-0 d-flex text-nowrap align-items-center">
            <span><CompanyIcon :color="getPrimaryColorHex.four"/></span>
            <span class="bold" v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice">Empresas</span>
            <span class="bold" v-else>Minha empresa</span>
            <span class="c-ndarkthree mx-2"> | </span>
            <span class="break mr-2">{{ $store.state.register.company.name | formatName }}</span>
            <!-- <CountDown :updatedAt="updatedAt" :status="registerStatus" v-if="registerActive"/> -->
            <!-- <CompanyStatus class="ml-3" :status="registerStatus" :cnpjId="$store.state.register.company.cnpjId"/> -->
        </h3>
        <p class="c-ndarkfour mt-2" v-html="subtitle">
    </p>
    </div>
    <div class="col-4 d-flex justify-content-end align-items-center px-0" >
        <!--<Button type="primary" @click="$router.push('/company/register/new')" :color="getPrimaryColor" v-if="!$store.state.user.userAdm && !USER_TYPE_MIXIN.isBackOffice">
            + Nova empresa
        </Button>-->
        <el-dropdown trigger="click" :hide-on-click="false" v-if="USER_TYPE_MIXIN.isAdm || USER_TYPE_MIXIN.isBackOffice">
            <Button type="secondary" size="small" :color="getPrimaryColor">Ações</Button>
            <el-dropdown-menu slot="dropdown" :color="getPrimaryColor" class="min-width-240">
                <ActionBtnItemsContainer :withoutBottomLine="company.cnpj.companyType === '2'">
                    <el-dropdown-item v-if="company.cnpj.registerComplete === 2 || company.cnpj.registerComplete === 3">
                        <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="sendReview(company.cnpjId)">
                            <Chat class="mr-2"/>Enviar mensagem
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <el-dropdown placement="left" trigger="click" v-if="company.cnpj.companyType !== '2'" >
                            <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                                <Clock class="mr-2"/>Alterar status do cadastro
                                <ArrowDropdown class="ml-4" :rotate="270" />
                            </span>
                            <el-dropdown-menu  slot="dropdown">
                                <el-dropdown-item>
                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClick(0)">
                                        <Sphere :color="'#FFAC00'" class="sphere mr-1" :size="'12'" /> Pendente
                                    </span>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClick(2)">
                                        <Sphere :color="'#FFAC00'" class="sphere mr-1" :size="'12'" /> Em análise
                                    </span>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClick(3)">
                                        <Sphere :color="'#FFAC00'" class="sphere mr-1" :size="'12'" /> Em revisão
                                    </span>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClick(1)">
                                        <Sphere :color="'#33BDA3'" class="sphere mr-1" :size="'12'" /> Completo
                                    </span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="company.cnpj.companyType == '1' && company.cnpj.canOperate == true">
                        <span class="c-ndarkthree medium pl-3 d-flex align-items-center" :class="company.cnpj.companyType == '1' || company.cnpj.registerActive != null ? 'mt-n1' : ''" @click="dialogVisibleCanOperate = true">
                            <Delete :strokeWidth="1" color="#A1A8B8" class="mr-2"/>Desabilitar antecipação
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="company.cnpj.companyType == '1' && company.cnpj.canOperate == false">
                        <span class="c-ndarkthree medium pl-3 d-flex align-items-center" :class="company.cnpj.companyType == '1' || company.cnpj.registerActive != null ? 'mt-n1' : ''" @click="dialogVisibleCanOperate = true">
                            <CheckPayment color="#A1A8B8" class="mr-2 ml-n1" size="20" />Habilitar antecipação
                        </span>
                    </el-dropdown-item>
                </ActionBtnItemsContainer>
                <ActionBtnItemsContainer withoutBottomLine>
                    <el-dropdown-item >
                        <span class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center" @click="downloadAll(company.id)">
                            <Download size="16" color="#A1A8B8" class="mr-2"/>Baixar documentos do cadastro
                        </span>
                    </el-dropdown-item>
                </ActionBtnItemsContainer>
                <ActionBtnItemsContainer withoutBottomLine v-if="USER_TYPE_MIXIN.isAdm || (USER_TYPE_MIXIN.isBackOffice && company.cnpj.companyType === '2')">
                    <el-dropdown-item v-if="company.cnpj.registerActive == true">
                        <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="changeCompanyIsActive(company.cnpjId, false)">
                            <Delete :strokeWidth="1" color="#A1A8B8" class="mr-2"/>Desativar a empresa
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="company.cnpj.registerActive == false">
                        <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="changeCompanyIsActive(company.cnpjId, true)">
                            <CheckPayment color="#A1A8B8" class="mr-2"/>Ativar a empresa
                        </span>
                    </el-dropdown-item>
                </ActionBtnItemsContainer>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
    <CompanyCanOperate :dialogVisible="dialogVisibleCanOperate" @closeModal="dialogVisibleCanOperate= $event" :canOperate="company.cnpj.canOperate" @changeCanOperate="changeCanOperate"/>
    <ChangeStatusRegister :dialogVisible="dialogVisibleStatus" @closeModal="dialogVisibleStatus = $event" @updateStatus="changeRegisterStatus()"/>
    <SendReviewRegister :dialogVisible="dialogVisibleReview" @closeModal="dialogVisibleReview = $event" :cnpjId="cnpjId" @sendReview="sucessSendReview"/>
</div>
</template>

<script>
// import CompanyStatus from '@/components/status/CompanyStatus'
// import CountDown from "@/components/countdown/CountDown";
import ActionBtnItemsContainer from "@/components/container/ActionBtnItemsContainer.vue";
import Clock from "../icons/Clock.vue";
import ArrowDropdown from "../icons/ArrowDropdown.vue";
import Sphere from "../icons/Sphere.vue";
import Delete from "../icons/Delete.vue";
import CheckPayment from "../icons/CheckPayment.vue";
import Download from "../icons/Download.vue";
import Chat from '../icons/Chat.vue'
import SendReviewRegister from "../modals/SendReviewRegister.vue";
import CompanyCanOperate from "../modals/CompanyCanOperate.vue";
import ChangeStatusRegister from "../modals/ChangeStatusRegister.vue";
import updateCanOperateCompany from "../../api/updateCanOperateCompany";
import downloadAllFilesProvider from "../../api/downloadAllFilesProvider";
import downloadArchive from "../../api/downloadArchive";
import updateRegisterStatusCompany from "../../api/updateRegisterStatusCompany";

export default {
    components: {
        // CompanyStatus,
        // CountDown,
        ActionBtnItemsContainer,
        Clock,
        ArrowDropdown,
        Sphere,
        Delete,
        CheckPayment,
        Download,
        CompanyCanOperate,
        ChangeStatusRegister,
        Chat,
        SendReviewRegister
    },
    data() {
        return {
            dialogVisibleCanOperate: false,
            dialogVisibleStatus: false,
            statusToChange: null,
            dialogVisibleReview: false,
            cnpjId: null,
        }
    },
    computed: {
        registerStatus() {
            return this.$store.state.register.company.cnpj ? this.$store.state.register.company.cnpj.registerComplete : false
        },
        registerActive() {
            return this.$store.state.register.company.cnpj ? this.$store.state.register.company.cnpj.registerActive : false
        },
        updatedAt() {
            return this.$store.state.register.company.cnpj ? this.$store.state.register.company.cnpj.updatedAt : false
        },
        lastUpdate() {
            const [year, month, rest] = this.updatedAt.split('-')
            const [day] = rest.split('T')
            return `${day}/${month}/${year}`
        },
        company() {
            const { cnpj, cnpjId, id } = this.$store.state.register.company
            return {cnpj, cnpjId, id}
        },
        subtitle() {
            if (!this.$store.state.user.userAdm && !this.USER_TYPE_MIXIN.isBackOffice) {
                return "Complete o cadastro da sua empresa."
            }
            const { registerComplete } = this.company.cnpj
            if (registerComplete == 0) {
                return "Nenhuma atualização foi realizada no cadastro da empresa"
            }
            if (registerComplete == 1) {
                return `Última atualização feita em ${this.lastUpdate}. ${this.expiresIn}`
            }
            else {
                return `Última atualização feita em ${this.lastUpdate}`
            }
        },
        expiresIn() {
            const expiresIn = new Date(this.updatedAt)
            expiresIn.setFullYear(expiresIn.getFullYear() + 1)

            const now = new Date()

            const diff = expiresIn - now
            const diffInDays = Math.round(diff / (3600 * 1000 * 24))
            
            if (diffInDays <= 365 && diffInDays >= 0) {
                return `Expira em <span class="bold">${diffInDays} dias.</span>`
            }
            return `Expirou há <span class="bold">${Math.abs(diffInDays)} dias.</span>`
        }
    },
    methods: {
        async changeCanOperate(boolean) {
            const { economicGroupIds } = this.$store.state.register
            const result = await updateCanOperateCompany(this.company.cnpjId, { canOperate: boolean, economicGroupIds })
            if (result.status === 204) {
                if (boolean == true) {   
                    this.$notify({
                        title: 'Antecipação habilitada com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                    });
                } else {
                    this.$notify({
                        title: 'Antecipação desabilitada com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                    });
                }
                const company = {
                    ...this.$store.state.register.company,
                }

                company.cnpj.canOperate = !!boolean

                this.$store.commit('register/setCompany', company)
                this.$emit('changedCanOperate')
                this.dialogVisibleCanOperate = false
            } else {
                this.$notify({
                    title: 'Ops, algo aconteceu de errado!',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
                this.dialogVisibleCanOperate = false
            }
        },
        async downloadAll(id) {
            this.$store.commit('user/setIsDownloadLoading', true)

            const result = await downloadAllFilesProvider(id)
            downloadArchive(`${process.env.VUE_APP_ROOT_API}/${result}`)

            setTimeout(() => {
                this.$store.commit('user/setIsDownloadLoading', false)
            }, 8000)
        },
        async changeRegisterStatus() {
            const result = await updateRegisterStatusCompany(this.company.cnpjId, { status: this.statusToChange }, this.getWhiteLabel)
            if (result.ok) {
                this.$notify({
                    title: 'Status alterado com sucesso!',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });

                const company = {
                    ...this.$store.state.register.company,
                }

                company.cnpj.registerComplete = this.statusToChange

                this.$store.commit('register/setCompany', company)
                this.dialogVisibleStatus = false

            } else {
                this.$notify({
                    title: 'Ops, algo aconteceu de errado!',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
                this.dialogVisibleStatus = false
            }
        },
        handleClick(status) {
            this.statusToChange = status
            this.dialogVisibleStatus = true
        },
        sendReview(cnpjId) {
            this.cnpjId = cnpjId
            this.dialogVisibleReview = true
        },
        sucessSendReview() {
            this.$emit('sucessSendReview', false)
        },
    },
     beforeDestroy() {
        this.$store.commit('register/setEconomicGroups', [])
    },
}
</script>

<style scoped>
.sphere {
    stroke: none !important;
}
.min-width-240 {
    min-width: 240px;
}
</style>